import MicroModal from 'micromodal';

/**
 * Expands the nested EU GARAN label into the full label.
 *
 * The listener is delegated because the checkout order summary is replaced by
 * WooCommerce ajax fragments on every totals refresh, which would drop any
 * handler bound directly to the trigger.
 */
const garanLabel = {
  init() {
    document.addEventListener('click', (e) => this.handleClick(e), false);
  },

  handleClick(e) {
    const trigger = e.target.closest('[data-garan-modal]');

    if (!trigger) {
      return;
    }

    const modal = document.querySelector('#modal-garan');
    const image = modal && modal.querySelector('.garan-modal__img');

    if (!image) {
      return;
    }

    image.src = trigger.dataset.garanSrc;
    image.alt = trigger.dataset.garanAlt || '';

    MicroModal.show('modal-garan');
  },
};

export default garanLabel;



// WEBPACK FOOTER //
// ./scripts/modules/garan-label.js